/*
 * @Author: lijinyang
 * @FilePath: /mall-fe/src/comps/Header.cscec3b.tsx
 * @Description: 商城首页头部入口容器组件
 *
 */
import HeaderContent from 'views/web/home/NewIndex/components/HeaderContent';
import MiniHeader from 'views/web/home/NewIndex/components/MinHeader';
import { HeaderNavNew } from 'comps/HeaderNav';
/**
 * React组件，商城首页前端的头部展示组件
 *
 * @param {boolean } showAreaCascader  - 是否展示头部地区层级筛选
 * @param {boolean } showNav - 是否展示头部导航
 * @returns {JSX.Element} 商城首页前端的头部展示组件
 */
export default function Header({ showAreaCascader = true, showNav = true, showCart = true }: any) {
  return (
    <div className="header">
      <MiniHeader />
      <HeaderContent showAreaCascader={showAreaCascader} showCart={showCart} />
      {/* {showNav && <HeaderNavNew />} */}
      <style jsx>{`
        .header {
          background-color: #fff;
          // box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.1);
          position: relative;
          z-index: 10;
        }
      `}</style>
    </div>
  );
}
